module.exports = require('./helpers/bundle-url').getBundleURL('7VwIV') + "statuspage-left.6c5cd6d4.svg";